/**
 * Token destinatario ammessi negli array `recipients` / `notification_recipients`
 * di `email_templates`.
 *
 * Non è un enum a DB (le colonne sono `text[]` libere): questa lista rispecchia i
 * valori realmente presenti nei dati e serve solo a popolare le multi-select. Un
 * token sconosciuto salvato altrove resta comunque visibile e rimovibile nella UI
 * (`MultiSelect` mostra i valori fuori lista come chip con label = valore grezzo).
 * Quando il backend introduce un nuovo destinatario, basta aggiungerlo qui e la
 * relativa etichetta i18n in `emailTemplates.recipientTokens.*`.
 */
export const RECIPIENT_TOKENS = [
  'admin',
  'td',
  'agency',
  'client',
  'td_or_admin',
] as const;

export type RecipientToken = (typeof RECIPIENT_TOKENS)[number];

/**
 * I due canali NON accettano gli stessi token.
 *
 * - `recipients` (email) è risolto da `trg_dispatch_mail_to_hetzner`, che gestisce
 *   admin / td / client / td_or_admin / agency.
 * - `notification_recipients` è risolto da `trg_fan_out_notifications`, che gestisce
 *   solo admin / td / client / agency: `td_or_admin` non ha un ramo e verrebbe
 *   **ignorato in silenzio**, quindi non va offerto nella multi-select delle notifiche.
 *
 * Verificato sulle definizioni delle funzioni in DEV/PROD.
 */
export const EMAIL_RECIPIENT_TOKENS = RECIPIENT_TOKENS;

export const NOTIFICATION_RECIPIENT_TOKENS = [
  'admin',
  'td',
  'agency',
  'client',
] as const satisfies readonly RecipientToken[];
